import { Injectable, signal } from '@angular/core';
import { PublicToastPayload, PublicToastType } from '@app/interfaces/public/public-toast.interfaces';

@Injectable({
  providedIn: 'root',
})
export class PublicToastService {
  private static readonly DISPLAY_DURATION_MS = 3000;

  readonly visible = signal(false);
  readonly title = signal('Notice');
  readonly message = signal('Please sign up first to continue.');
  readonly type = signal<PublicToastType>('info');
  readonly durationMs = signal(PublicToastService.DISPLAY_DURATION_MS);
  readonly sequence = signal(0);

  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  show(payload: PublicToastPayload): void {
    this.title.set(payload.title?.trim() || 'Notice');
    this.message.set(payload.message.trim() || 'Please sign up first to continue.');
    this.type.set(payload.type ?? 'info');
    this.durationMs.set(PublicToastService.DISPLAY_DURATION_MS);
    this.sequence.update((value) => value + 1);
    this.visible.set(true);

    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }

    this.hideTimer = setTimeout(() => {
      this.hide();
    }, this.durationMs());
  }

  hide(): void {
    this.visible.set(false);
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  getIcon(type: PublicToastType): string {
    if (type === 'success') return '✓';
    if (type === 'error') return '✕';
    if (type === 'warning') return '!';
    return 'i';
  }
}
